import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'
import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

export const shouldShowNDVI = () =>
  !HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD && !!selectedValueGroupsStore.getState().selectedValueGroups.ndvi
